import React from 'react';
import withStyles from '@mui/styles/withStyles';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import IconButton from '@mui/material/IconButton';
import PanLeftIcon from '@mui/icons-material/ChevronLeft';
import PanRightIcon from '@mui/icons-material/ChevronRight';
import Tooltip from '@mui/material/Tooltip';

const panStyle = {
  panGroup: {
    textAlign: 'center',
    minWidth: '2.5em',
    position: 'sticky',
    top: '0',
    margin: 'auto',
  },
  left: {
    marginLeft: '0',
  },
  right: {
    marginRight: '0',
  },
};

function PanControl({ classes, direction, spots, handlePan }) {
  const PanIcon = direction === 'left' ? PanLeftIcon : PanRightIcon;
  const Dir = direction.charAt(0).toUpperCase() + direction.substr(1);

  return spots <= 0 ? (
    <div className={classes.panGroup} />
  ) : (
    <div className={classnames(classes.panGroup, classes[direction])}>
      <Tooltip title={`Pan Chart ${Dir}. ${spots} Provider${spots !== 1 ? 's' : ''} Hidden`}>
        <IconButton onClick={handlePan} size="large">
          <PanIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
}

PanControl.propTypes = {
  handlePan: PropTypes.func.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  direction: PropTypes.string.isRequired,
  spots: PropTypes.number.isRequired,
};

export default withStyles(panStyle)(PanControl);
